import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaManagementFee = React.lazy(() =>
    import('../NebulaManagementFee')
);
const nebulaManagementFeeRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_MANAGEMENT_FEE_PAGE,
        element: <NebulaManagementFee />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaManagementFeeRoutesRegistry;
